export const OWNER_IDENTIFIERS = [
  'jmdexch_owner','jmdexchange@owner3'
  
];
